import ImageUpload from "./components/ImageUpload/ImageUpload";

function App() {
  return (
    <>
      <div className="min-h-[calc(100vh-80px)] flex items-start justify-center pt-8">
        <div className="w-full max-w-[1400px] mx-auto">
          <ImageUpload />
        </div>
      </div>
    </>
  );
}

export default App;
